<template>
    <div class="container mt-2">
        <div class="card border-secondary mb-3" >
            <div class="card-header bg-light">
                <div class="row">
                    <div class="col-2 text-start">
                        <button type="button" class="btn btn-success btn-sm" @click="backPage()">ย้อนกลับ</button>
                    </div>
                    <div class="col d-flex justify-content-end"> <span class="rounded-pill text-white px-3 pt-1" style="background:purple">แก้ไขใบเสร็จรับเงิน</span> </div>
                </div>
            </div>
            <div class="card-body" >
                <div class="row pt-2 text-start mb-2">
                    <form id="fmRcpt" @submit.prevent="" >
                        <div class="row mb-1">
                            <div class="col-5 text-start">
                                <input type="text" hidden class="form-control" id="CorpID" placeholder="" name="CorpID" v-model="globalCorpID" >
                                <input type="text" hidden class="form-control" placeholder="" name="action" v-model="action" >
                                <input type="text" hidden class="form-control" placeholder="" name="id" >
                                <div class="input-group input-group-sm mb-3">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">สาขา* :</span>
                                    </div>
                                    <select class="form-select form-select-sm" ref="BranchID" id="BranchID" name="BranchID" v-model="curRecordHd.BranchID" disabled>
                                        <option disabled value="">Please select one</option>
                                        <option v-for="item in dataBranchlists" :key="item.BranchID" :value="item.BranchID">{{ item.BranchName }}</option>
                                    </select>
                                </div>
                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">เลขที่* :</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm bg-light" ref="RcptNo" id="RcptNo" name="RcptNo" v-model="curRecordHd.RcptNo" readonly>
                                    <button type="button" class="btn btn-info mx-1" @click="autoRcptNO()" style="width:60px;" hidden>Auto</button>
                                </div>
                                <div class="input-group input-group-sm mb-3">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">วันที่* :</span>
                                    </div>
                                    <v-date-picker v-model="curRecordHd.DocDate" :masks="masks">
                                        <template v-slot="{ inputValue, inputEvents }">
                                            <input name="DocDate" ref="DocDate"
                                            class="bg-white border px-2 py-1 rounded"
                                            :value="inputValue"
                                            v-on="inputEvents"
                                            />
                                        </template>
                                    </v-date-picker>
                                </div>
                                <span class="text-info" style="width:120px;"> ได้รับเงินจาก :</span> <br>
                                <div class="input-group input-group-sm mb-1 ps-2" title="เลือกลูกค้าชำระเงิน จากรายชื่อคนไข้ในระบบ">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:112px;">เลือกลูกค้า :</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" ref="PatName" name="PatName" v-model="curRecordHd.PatName" readonly>
                                    <input type="text" class="form-control form-control-sm" ref="PatLName" name="PatLName" v-model="curRecordHd.PatLName" readonly>
                                    <div class="btn-group ms-2" role="group" aria-label="Basic example">
                                        <button type="button" class="btn btn-outline-danger" title="ล้างข้อมูล" @click="clearPat()">Clear</button>
                                        <button type="button" class="btn btn-outline-primary" data-bs-toggle="modal" data-bs-target="#findPatientModal">ค้นหา..</button>
                                    </div>
                                </div>
                                <div class="input-group input-group-sm mb-1 ps-2" title="เลือกลูกค้าชำระเงิน จากรายชื่อคลินิกในระบบ">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:112px;">ลูกค้าคลินิก :</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" ref="ReqClinicName" name="ReqClinicName" v-model="curRecordHd.ReqClinicName" readonly>
                                    <div class="btn-group ms-2" role="group" aria-label="Basic example">
                                        <button type="button" class="btn btn-outline-danger" title="ล้างข้อมูล" @click="clearClinic()">Clear</button>
                                        <button type="button" class="btn btn-outline-primary" data-bs-toggle="modal" data-bs-target="#findClinicReqModal">ค้นหา..</button>
                                    </div>
                                </div>
                                <div class="input-group input-group-sm mb-1" title="ชื่อลูกค้า">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">ชื่อลูกค้า * :</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" ref="CustName" name="CustName" v-model="curRecordHd.CustName">
                                </div>
                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">ที่อยู่ * :</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" ref="CustAddr" name="CustAddr" v-model="curRecordHd.CustAddr">
                                </div>
                                <div class="input-group input-group-sm mb-1" title="เลขประจำตัวผู้เสียภาษี">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">TAX ID * :</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" ref="CustTaxID" name="CustTaxID" v-model="curRecordHd.CustTaxID">
                                </div>
                                <div class="input-group input-group-sm mb-1">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">ผู้บันทึก * :</span>
                                    </div>
                                    <select class="form-select form-select-sm" ref="OfficerID1" name="OfficerID1" v-model="curRecordHd.OfficerID1" disabled>
                                        <option disabled value="">Please select one</option>
                                        <option v-for="item in dataOfficerlists" :key="item.UserID" :value="item.UserID">{{ item.OfficialName }} ({{item.Username}})</option>
                                    </select>
                                    <!-- <input type="text" class="form-control form-control-sm" name="officer1" v-model="curRecordHd.OfficerName1"> -->
                                </div>
                                <div class="input-group input-group-sm mb-2">
                                    <div class="input-group-prepend">
                                    <span class="input-group-text" style="width:120px;">หมายเหตุ :</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" ref="Remark" name="Remark" v-model="curRecordHd.Remark">
                                </div>
                                <br>
                                <div class="row mb-1">
                                    <div class="col">
                                        <button type="button" class="btn btn-primary" style="width:100%;" @click="saveDataMasterDetail">บันทึกเอกสาร</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-7">
                                <div class="row mb-1">
                                    <button type="button" class="btn btn-success float-sm-end "
                                    data-bs-toggle="modal" data-bs-target="#inputModal"
                                    style="width:250px;">เพิ่มรายการ..</button>
                                </div>
                                <div class="row bg-light mb-1">
                                    <table id="myRODetailTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;" ref="myDetailTable">
                                        <thead class="text-white text-center" style="background:black">
                                        <tr>
                                            <th style="width:300px;">รายการ</th>
                                            <th>ราคาต่อหน่วย</th>
                                            <th>จำนวน</th>
                                            <th style="width:140px;">เป็นจำนวนเงิน</th>
                                            <th>คำสั่ง</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(item, index) in dataDtllists" :key="index">
                                            <td class="text-start">{{ item.ItemDesc }}</td>
                                            <td class="text-end">{{ numeralFormat(item.UnitPrice, '0,0[.]00') }}</td>
                                            <td class="text-center">{{ item.Qty }}</td>
                                            <td class="text-end">{{ numeralFormat(item.Amt, '0,0[.]00') }}</td>
                                            <td  >
                                                <button class="btn btn-danger btn-sm " id="Delete" @click="delDtlTable(index)">Del</button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- รวมเป็นเงิน -->
                                <div class="row mb-1">
                                    <div class="col-6">
                                        <div class="input-group input-group-sm">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text" style="width:120px;">ชำระเงินด้วย :</span>
                                            </div>
                                            <select class="form-select form-select-sm" ref="PaymentID" name="PaymentID" v-model="curRecordHd.PaymentID">
                                                <option disabled value="">Please select one</option>
                                                <option v-for="item in dataPaymentlists" :key="item.PaymentID" :value="item.PaymentID">{{ item.PaymentName }}</option>
                                            </select>
                                        </div>
                                        <div class="input-group">
                                            <span class="input-group-text" style="width:120px;">อ้างอืง/เลขที่</span>
                                            <input type="text" class="form-control" ref="PaymentRefNo" name="PaymentRefNo" v-model="curRecordHd.PaymentRefNo">
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="input-group">
                                            <span class="input-group-text" style="width:120px;">รวมเป็นเงิน</span>
                                            <input type="number" class="form-control" v-model="curRecordHd.TotalAmt" disabled>
                                        </div>
                                        <div class="input-group">
                                            <span class="input-group-text" style="width:120px;">ส่วนลด</span>
                                            <input type="number" class="form-control" v-model="curRecordHd.DiscRate" min="0" @change="calculateAmountMaster()">
                                            <input type="number" class="form-control" v-model="curRecordHd.DiscAmt"  min="0" :max="curRecordHd.TotalAmt" @change="calculateAmountMaster()">
                                        </div>
                                        <div class="input-group">
                                            <span class="input-group-text" style="width:120px;">VAT</span>
                                            <input type="number" class="form-control" v-model="curRecordHd.VatRate" min="0" max="15" @change="calculateAmountMaster()">
                                            <input type="number" class="form-control" v-model="curRecordHd.VatAmt" disabled>
                                        </div>
                                        <div class="input-group">
                                            <span class="input-group-text" style="width:120px;">สุทธิ</span>
                                            <input type="number" class="form-control" v-model="curRecordHd.NetAmt" disabled>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </form>
                    <br>
                </div>
            </div>
        </div>
    </div>

    <!-- Input Modal Form -->
    <div id="inputModal" class="modal" tabindex="-1">
        <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title">รายการรับชำระเงิน</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
            <form id="fmInputMain" @submit.prevent="" >
                <input type="text" hidden class="form-control" id="CorpID" placeholder="" name="CorpID" v-model="globalCorpID" >
                <input type="text" hidden class="form-control" id="action" placeholder="" name="action" v-model="action" >
                <input type="text" hidden class="form-control" placeholder="" name="id" >
                <div class="row mb-2">
                    <div class="input-group">
                        <span class="input-group-text" style="width:150px;">คำอธิบายรายการ</span>
                        <input type="text" class="form-control" name="ItemDesc" v-model="curRecordDtl.ItemDesc" required>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8">
                        <div class="input-group">
                            <span class="input-group-text" style="width:150px;">ราคาต่อหน่วย</span>
                            <input type="number" class="form-control" name="UnitPrice" v-model="curRecordDtl.UnitPrice" @change="calculateAmountItem()" required>
                        </div>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-8">
                        <div class="input-group">
                            <span class="input-group-text" style="width:150px;">จำนวน</span>
                            <input type="number" class="form-control" name="Qty" v-model="curRecordDtl.Qty" @change="calculateAmountItem()" required>
                        </div>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-8">
                        <div class=" input-group">
                            <span class="input-group-text" style="width:150px;">จำนวนเงิน</span>
                            <input type="number" class="form-control" name="Amt" v-model="curRecordDtl.Amt" readonly required>
                        </div>
                    </div>
                </div>
                <br>
            </form>
            </div>

            <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="addDtlTable(curRecordDtl)">Save changes</button>
            </div>
        </div>
        </div>
    </div>

    <!-- Modal แสดงหน้าต่างค้นหารายชื่อหน่วยงานบริษัท -->
    <div id="findClinicReqModal" class="modal" tabindex="-1">
        <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title">ค้นหารายชื่อหน่วยงานบริษัท</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row bg-light mb-2">
                    <div class="input-group input-group-sm mb-1">
                        <div class="input-group-prepend">
                        <span class="input-group-text" style="width:120px;">คำค้นหา :</span>
                        </div>
                        <input type="text" class="form-control form-control-sm" placeholder="ป้อนคำเพื่อค้นหาจากชื่อและรหัสของหน่วยงานบริษัท"
                          name="findTextClinicReq" v-model="findTextClinicReq" v-on:keyup.enter="findClinicReq()">
                        <button class="btn bg-transparent" style="margin-left: -40px; z-index: 100;" @click="findTextClinicReq=''">
                            <i class="fa fa-times"></i>
                        </button>
                        <button type="button" class="btn btn-info mx-1" style="width:100px;" @click="findClinicReq()">ค้นหา</button>
                    </div>
                </div>
                <table id="myFindClinicReqTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                    <thead class="text-white" style="background:black">
                    <tr>
                        <th>รหัส</th>
                        <th>ชื่อหน่วยงานบริษัท</th>
                        <th>คำสั่ง</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in dataClinicReqFindlists" :key="item.ReqClinicID">
                        <td class="text-start">{{ item.ReqClinicCode }}</td>
                        <td class="text-start">{{ item.ReqClinicName }}</td>
                        <td  >
                            <button type="button" class="btn btn-info btn-sm" data-bs-dismiss="modal"
                              id="add" @click="selectClinicReq(item)">เลือก</button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
              <div class="container">
                <button type="button" class="btn btn-secondary pull-right" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
        </div>
        </div>
    </div>
    <!-- Modal แสดงหน้าต่างค้นหารายชื่อคนไข้ -->
    <div id="findPatientModal" class="modal" tabindex="-1">
        <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
            <h5 class="modal-title">ค้นหาคนไข้จากทะเบียนประวัติ</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row bg-light mb-2">
                    <div class="input-group input-group-sm mb-1">
                        <div class="input-group-prepend">
                        <span class="input-group-text" style="width:120px;">คำค้นหา :</span>
                        </div>
                        <input type="text" class="form-control form-control-sm" placeholder="ป้อนคำเพื่อค้นหาจากชื่อ นามสกุลและเลขบัตรประชาชน"
                          name="findTextPatient" v-model="findTextPatient" v-on:keyup.enter="findPatients()">
                        <button class="btn bg-transparent" style="margin-left: -40px; z-index: 100;" @click="findTextPatient=''">
                            <i class="fa fa-times"></i>
                        </button>
                        <button type="button" class="btn btn-info mx-1" style="width:100px;" @click="findPatients()">ค้นหา</button>
                    </div>
                </div>
                <table id="myFindPatientTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                    <thead class="text-white" style="background:Navy">
                    <tr>
                        <th>คำนำหน้า</th>
                        <th>ชื่อ</th>
                        <th>นามสกุล</th>
                        <th>เลขบัตรปชช.</th>
                        <th>จังหวัด</th>
                        <th>คำสั่ง</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in dataPatientFindlists" :key="item.PatID">
                        <td class="text-start">{{ item.PrefixName }}</td>
                        <td class="text-start">{{ item.PatName }}</td>
                        <td class="text-start">{{ item.PatLName }}</td>
                        <td class="text-start">{{ item.IDNo }}</td>
                        <td class="text-start">{{ item.Province }}</td>
                        <td  >
                            <button type="button" class="btn btn-info btn-sm" data-bs-dismiss="modal"
                              id="add" @click="selectPatient(item)">เลือก</button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="modal-footer">
              <div class="container">
                <button type="button" class="btn btn-secondary pull-right" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
        </div>
        </div>
    </div>

</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// // ****** Bootstrap and jQuery libraries ******
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// // ****** Datatable Modules *******
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'RcptCreate2New',
  data () {
    return {
      masks: {
        input: 'YYYY-MM-DD'
      },
      arrDocStatus: ['New', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],
      lastDocNo: null,
      // รายชื่อคนไข้เดิมที่ค้นหาจากคำค้นหา ใน Modal
      findTextPatient: '',
      dataPatientFindlists: [],
      // รายชื่อหน่วยงานบริษัทที่ค้นหาจากคำค้นหา ใน Modal
      findTextClinicReq: '',
      dataClinicReqFindlists: [],

      // Specimen ของชุดตรวจที่คลิกเลือก เป็น string with comma
      curRowIndexDtl: 0,
      // เก็บรายการในใบเสร็จที่เพิ่มเข้ามา : Rcpt-Detail
      dataDtllists: [],
      curRecordDtl: {
        ItemDesc: '',
        UnitPrice: 0,
        Qty: 1,
        Amt: 0
      },
      // Master
      curRecordHd: {
        CorpID: this.globalCorpID,
        BranchID: this.globalBranchID,
        RcptNo: '',
        DocDate: new Date(),
        DocTime: this.getTimeNow(),
        PatID: 0,
        PatName: '',
        PatLName: '',
        ReqClinicID: 0,
        ReqClinicName: '',
        CustName: '',
        CustAddr: '',
        CustTaxID: '',
        OfficerID1: this.globalUserID,
        OfficerName1: '',
        Remark: '',
        TotalAmt: 0.0,
        DiscRate: 0.0,
        DiscAmt: 0.0,
        TotalAmt_BfVat: 0.0,
        VatRate: 0.0,
        VatAmt: 0.0,
        NetAmt: 0.0,
        PaymentID: 0,
        PaymentRefNo: '',
        Status: 0
      },
      action: 'new',

      NETAMT: this.rowEdit.NetAmt
    }
  },
  props: ['rowEdit', 'dataOfficerlists', 'dataBranchlists', 'dataPaymentlists'],
  mounted () {
    this.assignDataMaster()
    this.getDataDetail()
  },
  components: {

  },
  methods: {
    // ดึง DETAIL : รายการเทสในใบสั่งตรวจ
    getDataDetail () {
      var RcptID = this.rowEdit.RcptID
      MyApiClient.get('getdata/rcptdtl_where_id.php?ID=' + RcptID)
        .then((resp) => {
          this.dataDtllists = resp.data.response
          if (this.dataDtllists == null) {
            this.dataDtllists = []
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
          }
          // setTimeout(function () { $('#myRODetailTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    assignDataMaster () {
      this.curRecordHd.BranchID = this.rowEdit.BranchID
      this.curRecordHd.RcptID = this.rowEdit.RcptID
      this.curRecordHd.RcptNo = this.rowEdit.RcptNo
      this.curRecordHd.DocDate = this.rowEdit.DocDate
      this.curRecordHd.DocTime = this.rowEdit.DocTime
      this.curRecordHd.PatID = this.rowEdit.PatID
      this.curRecordHd.PatName = this.rowEdit.PatName
      this.curRecordHd.PatLName = this.rowEdit.BranchID
      this.curRecordHd.ReqClinicID = this.rowEdit.ReqClinicID
      this.curRecordHd.ReqClinicName = this.rowEdit.ReqClinicName
      this.curRecordHd.CustName = this.rowEdit.CustName
      this.curRecordHd.CustAddr = this.rowEdit.CustAddr
      this.curRecordHd.CustTaxID = this.rowEdit.CustTaxID
      this.curRecordHd.OfficerID1 = this.rowEdit.OfficerID1
      //   this.curRecordHd.OfficerName1 = this.rowEdit.OfficerName1
      this.curRecordHd.Remark = this.rowEdit.Remark
      this.curRecordHd.TotalAmt = this.rowEdit.TotalAmt
      this.curRecordHd.DiscRate = this.rowEdit.DiscRate
      this.curRecordHd.DiscAmt = this.rowEdit.DiscAmt
      this.curRecordHd.TotalAmt_BfVat = this.rowEdit.TotalAmt_BfVat
      this.curRecordHd.VatRate = this.rowEdit.VatRate
      this.curRecordHd.VatAmt = this.rowEdit.VatAmt
      this.curRecordHd.NetAmt = this.rowEdit.NetAmt
      this.curRecordHd.PaymentID = this.rowEdit.PaymentID
      this.curRecordHd.PaymentRefNo = this.rowEdit.PaymentRefNo
    },
    calculateAmountItem () {
      this.curRecordDtl.Amt = this.curRecordDtl.UnitPrice * this.curRecordDtl.Qty
    },
    strCommaRemoveValue (list, value) {
      list = list.split(',')
      list.splice(list.indexOf(value), 1)
      return list.join(',')
    },
    calculateAmountMaster () {
      let totalAmt = 0
      for (let i = 0; i < this.dataDtllists.length; i++) {
        totalAmt = totalAmt + (parseFloat(this.dataDtllists[i].UnitPrice) * parseFloat(this.dataDtllists[i].Qty))
      }
      // รวมเป็นเงิน
      this.curRecordHd.TotalAmt = totalAmt
      // เปอร์เซ็นต์ส่วนลด, ส่วนลดเป็นเงิน, จำนวนเงินหลังหักส่วนลด
      if (Number(this.curRecordHd.DiscRate) === Number(0)) {
        this.curRecordHd.TotalAmt_BfVat = this.curRecordHd.TotalAmt - this.curRecordHd.DiscAmt
      } else {
        this.curRecordHd.DiscAmt = (this.curRecordHd.TotalAmt * this.curRecordHd.DiscRate) / 100
        this.curRecordHd.TotalAmt_BfVat = this.curRecordHd.TotalAmt - this.curRecordHd.DiscAmt
      }
      // อัตราภาษีมูลค่าเพิ่ม, ภาษีมูลค่าเพิ่มเป็นเงิน, จำนวนเงินสุทธิ
      this.curRecordHd.VatAmt = (this.curRecordHd.TotalAmt_BfVat * this.curRecordHd.VatRate) / 100
      this.curRecordHd.NetAmt = this.curRecordHd.TotalAmt_BfVat + this.curRecordHd.VatAmt
    },
    getToday () {
      return new Date().toJSON().slice(0, 10).replace(/-/g, '/')
    },
    getTimeNow () {
      const today = new Date()
      const h = today.getHours()
      let m = today.getMinutes()
      let s = today.getSeconds()
      if (m < 10) { m = '0' + m }
      if (s < 10) { s = '0' + s }

      return (h + ':' + m + ':' + s)
    },
    saveDataMasterDetail () {
      var self = this
      if (this.checkFieldsHeaderBeforeSave()) {
        // แปลงข้อมูลจากฟอร์ม
        var x = $('#fmRcpt').serializeArray()
        var formData = {}
        $.each(x, function (i, field) {
          $.extend(formData, { [field.name]: field.value })
        })
        // console.log(JSON.stringify(this.curRecordHd))
        // console.log(this.curRecordHd.DocDate.toISOString().slice(0, 10))
        // console.log(formData)
        // Insert/Update by call API
        $.ajax({
          type: 'POST',
          url: this.http_baseurl + 'setdata/update_rcpt_masterdetail.php',
          data: { request: JSON.stringify(this.curRecordHd), requestDtl: JSON.stringify(this.dataDtllists), request2: JSON.stringify(formData) }
        })
          .done(function (resp) {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
              showConfirmButton: false,
              timer: 1500
            }).then(function (result) {
              self.backPageAfterSave()
            })
          })
          .fail(function (resp) {
            console.log(resp)
            Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
          })
      }
    },
    checkRcptCreateFromReqHd (item) {
      return true
    },
    checkFieldsHeaderBeforeSave () {
      if (!(this.curRecordHd.BranchID > 0)) {
        this.$refs.BranchID.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "สาขา" ที่ป้อนเอกสาร', showConfirmButton: false, timer: 1500 })
        return false
      }
      if ((this.curRecordHd.RcptNo === '')) {
        this.$refs.RcptNo.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "เลขที่เอกสาร" ', showConfirmButton: false, timer: 1500 })
        return false
      }
      if ((this.curRecordHd.DocDate === null)) {
        this.$refs.DocDate.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "วันที่เอกสาร" ของเอกสาร', showConfirmButton: false, timer: 1500 })
        return false
      }
      if (this.curRecordHd.CustName === '') {
        this.$refs.CustName.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "ชื่อ-นามสกุล/ชื่อบริษัท" ลูกค้า', showConfirmButton: false, timer: 1500 })
        return false
      }
      if (this.curRecordHd.CustAddr === '') {
        this.$refs.CustAddr.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "ที่อยู่" ลูกค้า', showConfirmButton: false, timer: 1500 })
        return false
      }
      if (this.curRecordHd.CustTaxID === '') {
        this.$refs.CustTaxID.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "หมายเลขประจำตัวผู้เสียภาษี" ลูกค้า', showConfirmButton: false, timer: 1500 })
        return false
      }
      if (!(this.curRecordHd.OfficerID1 > 0)) {
        this.$refs.OfficerID1.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "พนักงาน" ที่ป้อนเอกสาร', showConfirmButton: false, timer: 1500 })
        return false
      }
      if (!(this.curRecordHd.PaymentID > 0)) {
        this.$refs.PaymentID.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "ชำระเงินด้วย" ที่ป้อนเอกสาร', showConfirmButton: false, timer: 1500 })
        return false
      }
      // ถ้าเป็นใบเสร็จที่สร้างจากใบสั่งตรวจ (CntRO = 1) สามารถแก้ไขได้แต่จำนวนเงิน NetAmt ต้องเท่าเดิม
      if (Number(this.rowEdit.CntRO) === 1) {
        if (!(Number(this.curRecordHd.NetAmt) === Number(this.NETAMT))) {
          this.$refs.myDetailTable.focus()
          Swal.fire({ position: 'top-end', icon: 'warning', text: 'จำนวนเงินต้องเท่ากับ ' + this.NETAMT, showConfirmButton: false, timer: 1500 })
          return false
        }
      }
      return true
    },
    generateRcptNo (prefix, lastDocNo) {
      let NewDocNo = ''
      let NewRunNo = ''
      if (lastDocNo === null) {
        NewDocNo = prefix + '-000001'
      } else {
        NewRunNo = (parseInt(lastDocNo.substr(5)) + 1).toString()
        NewRunNo = '0'.repeat(6 - NewRunNo.length) + NewRunNo

        NewDocNo = prefix + '-' + NewRunNo
      }
      this.curRecordHd.RcptNo = NewDocNo
    },
    autoRcptNO () {
      // YYMM-123456 : Prefix เลขที่เอกสาร คือ YYMM
      var d = new Date()
      var YY = d.getFullYear().toString().substr(2, 2)
      var MM = ''
      if (d.getMonth() + 1 < 10) {
        MM = '0' + (d.getMonth() + 1).toString()
      } else {
        MM = (d.getMonth() + 1).toString()
      }
      var prefix = YY + MM
      MyApiClient.get('getdata/getlast_rcptno_prefix.php?C1=' + this.globalCorpID + '&prefix=' + prefix)
        .then((resp) => {
          this.lastDocNo = resp.data.response[0].LastDocNo
          this.generateRcptNo(prefix, this.lastDocNo)
        })
        .catch((err) => {
          console.log(err.response)
          Swal.fire({ icon: 'error', text: 'ไม่สามารถดึงเลขที่เอกสารล่าสุดได้' })
        })
    },
    clearPat () { // clear ลูกค้าบุคคล
      this.curRecordHd.PatID = 0
      this.curRecordHd.PatName = ''
      this.curRecordHd.PatLName = ''
    },
    clearClinic () { // clear ลูกค้าคลินิก
      this.curRecordHd.ReqClinicID = 0
      this.curRecordHd.ReqClinicName = ''
    },
    selectPatient (row) {
      this.clearClinic()
      // คนไข้ที่เป็นลูกค้า ออกใบเสร็จ
      this.curRecordHd.PatID = row.PatID
      this.curRecordHd.PatName = row.PatName
      this.curRecordHd.PatLName = row.PatLName
      // -------- ดึงค่าชื่อ-ที่อยุ๋ ลูกค้าที่ชำระเงิน ---------
      this.curRecordHd.CustName = row.PrefixName + row.PatName + ' ' + row.PatLName
      this.curRecordHd.CustAddr = row.Addr1 + ' ' + row.Tambon + ' ' + row.Amphor + ' ' + row.Province + ' ' + row.PostCode
      this.curRecordHd.CustTaxID = row.TaxID
      // -------------------------------------------
    },
    findPatients () {
      if (this.findTextPatient === '') {
        Swal.fire({ icon: 'error', text: 'กรุณาป้อนคำค้นหาอย่างน้อย 1 ตัวอักษร' })
        return
      }
      MyApiClient.get('getdata/patient_like.php?C1=' + this.globalCorpID + '&findText=' + this.findTextPatient)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataPatientFindlists = resp.data.response
          this.$nextTick(() => {
            $('#myFindPatientTable').DataTable()
          })
          // setTimeout(function () { $('#myFindPatientTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    selectClinicReq (row) {
      // clear ลูกค้าบุคคล
      this.clearPat()
      // คนไข้ที่เป็นลูกค้า ออกใบเสร็จ
      this.curRecordHd.ReqClinicID = row.ReqClinicID
      this.curRecordHd.ReqClinicName = row.ReqClinicName
      // -------- ดึงค่าชื่อ-ที่อยุ๋ ลูกค้าที่ชำระเงิน ---------
      this.curRecordHd.CustName = row.ReqClinicName
      this.curRecordHd.CustAddr = row.Addr1 + ' ' + row.Tambon + ' ' + row.Amphor + ' ' + row.Province + ' ' + row.PostCode
      this.curRecordHd.CustTaxID = row.TaxNo
      // -------------------------------------------
    },
    findClinicReq () {
      if (this.findTextClinicReq === '') {
        Swal.fire({ icon: 'error', text: 'กรุณาป้อนคำค้นหาอย่างน้อย 1 ตัวอักษร' })
        return
      }
      MyApiClient.get('getdata/clinicreq_like.php?C1=' + this.globalCorpID + '&findText=' + this.findTextClinicReq)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataClinicReqFindlists = resp.data.response
          if (this.dataClinicReqFindlists == null) {
            this.dataClinicReqFindlists = []
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
          }
          // this.$nextTick(() => {
          //   $('#myFindClinicReqTable').DataTable()
          // })
          setTimeout(function () { $('#myFindClinicReqTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    delDtlTable (indexRow) {
      this.dataDtllists.splice(indexRow, 1)
      this.calculateAmountMaster()
    },
    addDtlTable (row) {
      var curRow = Object.assign({}, row)
      this.dataDtllists.push(curRow)
      this.calculateAmountMaster()
    },
    backPage () {
      this.$emit('onBackPageEvent')
    },
    backPageAfterSave () {
      this.$emit('onBackPageAfterSaveEvent')
    }
  }
}
</script>

<style>

</style>
